/* eslint-disable @typescript-eslint/ban-ts-comment */

/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useState } from "react";
import {
  TextControlTypes,
  TEXT_CONTROLS_ALIGNMENT_SETTINGS,
} from "~/CustomizableToolPage/CustomizableTool/constants";
import useCustomizableContext from "~/CustomizableToolPage/useCustomizableContext";

interface Props {
  activeClientIdentifier: string;
}

const TextControls = ({ activeClientIdentifier }: Props) => {
  const [alignmentSelection, setAlignmentSelection] = useState<Lookup<string>>(
    {},
  );

  const {
    fabric: { canvas },
  } = useCustomizableContext();

  const updateAlignmentSelection = useCallback(
    (alignmentType: string, clientIdentifer: string) => {
      const temp = { ...alignmentSelection };

      temp[clientIdentifer] = alignmentType;

      setAlignmentSelection(temp);
    },
    [alignmentSelection],
  );

  const alignmentClickHandler = useCallback(
    (type: string, event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      event.preventDefault();

      const activeObj = canvas.getActiveObject() as fabric.IText;

      if (!activeObj) {
        return;
      }

      switch (type) {
        case TextControlTypes.left:
          activeObj.set({ left: 0 }).setCoords();
          break;
        case TextControlTypes.right:
          activeObj
            .set({ left: canvas!.width! - activeObj!.width! })
            .setCoords();
          break;
        case TextControlTypes.center:
          canvas.centerObjectH(activeObj);
          break;
        default:
          break;
      }

      canvas.fire("object:modified", { target: { canvas } });

      // Ensure that the cursor moves with the text box...
      activeObj.initDelayedCursor();

      // Allow user to keep editing after the move...
      activeObj?.hiddenTextarea?.focus();

      canvas.requestRenderAll();

      // @ts-ignore
      updateAlignmentSelection(type, activeObj.clientIdentifier);
    },
    [canvas, updateAlignmentSelection],
  );

  return (
    <div id="text-controls" className="customize__align-container">
      {!!activeClientIdentifier.length && (
        <div
          className={`customize__align-list ${
            activeClientIdentifier.length ? "" : "disabled"
          }`}
        >
          {TEXT_CONTROLS_ALIGNMENT_SETTINGS.map((item, index) => (
            <a
              href="#"
              className={`customize__align ${
                alignmentSelection[activeClientIdentifier] === item.type &&
                !!activeClientIdentifier.length
                  ? "active"
                  : ""
              }`}
              key={index}
              onClick={(e) => alignmentClickHandler(item.type, e)}
            >
              <img src={item.icon} alt={`${item.type} button`} />
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default TextControls;
